import React from "react";
import ContentContainer from "../../containers/ContentContainer";
import RelatedArticles from "../RelatedArticles";
import { Comment as CommentType } from "@/src/types/comments";
import ArticleComments from "../../Comments/ArticleComments";
import DangerouslySetHtmlContent from "./ExecutableScript";
import ContentRaw from "./ContentRaw";
import dynamic from "next/dynamic";

const ClientRenderer = dynamic(() => import("./ClientRenderer"), {
  ssr: false,
});

export interface ArticleContentProps {
  postId: number;
  postContent: any;
  relatedPosts: any;
  comments: CommentType[];
  raw?: boolean;
}

const ArticleContent = ({
  postId,
  postContent,
  relatedPosts,
  comments,
  raw = false,
}: ArticleContentProps) => {
  return (
    <>
      <ContentContainer bgColor="white">
        <div className={"flex flex-col gap-4 md:py-4 bg-white 123"}>
          <div className={"bodycontent container font-sans"}>
            {postContent && !raw ? (
              <DangerouslySetHtmlContent
                html={postContent}
                allowRerender
                className="bodycontent"
              />
            ) : (
              <ContentRaw content={postContent} />
            )}
            <ClientRenderer />
          </div>
        </div>
      </ContentContainer>
      <ArticleComments comments={comments} postId={postId} />
      <div style={{ width: "100%" }} className={"bg-slate-100 py-2"}>
        <ContentContainer paddingClass="p-2">
          <RelatedArticles articles={relatedPosts} />
        </ContentContainer>
      </div>
    </>
  );
};

export default ArticleContent;
